import {Injectable} from '@angular/core';
import {Subject} from "rxjs";


/**
 * 화면에 표시되는 붉은 끈의 클릭을 처리하기위한 서비스
 * 컴토넌트간의 데이터를 전달할 필요가 있어서 별도의 서비스로 제작함.
 */
@Injectable({
  providedIn: 'root'
})
export class RedPipeService {

  private click$ = new Subject<MouseEvent>();

  constructor() {
  }


  public get Click$() {
    return this.click$;
  }

  public Click(event: MouseEvent) {
    this.click$.next(event);
  }
}
